/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Seo_Rate_Audio_MinutesInputs */

const en_seo_rate_audio_minutes = /** @type {(inputs: Seo_Rate_Audio_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} per 1,000 audio minutes`)
};

const zh_hans1_seo_rate_audio_minutes = /** @type {(inputs: Seo_Rate_Audio_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每千分钟音频 ${i?.rate}`)
};

const pt_br2_seo_rate_audio_minutes = /** @type {(inputs: Seo_Rate_Audio_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por mil minutos de áudio`)
};

const es_seo_rate_audio_minutes = /** @type {(inputs: Seo_Rate_Audio_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por cada 1,000 minutos de audio`)
};

const fr_seo_rate_audio_minutes = /** @type {(inputs: Seo_Rate_Audio_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pour 1 000 minutes audio`)
};

const de_seo_rate_audio_minutes = /** @type {(inputs: Seo_Rate_Audio_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pro 1.000 Audiominuten`)
};

const ru_seo_rate_audio_minutes = /** @type {(inputs: Seo_Rate_Audio_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} за 1000 минут аудио`)
};

const it_seo_rate_audio_minutes = /** @type {(inputs: Seo_Rate_Audio_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} ogni 1.000 minuti di audio`)
};

/**
* | output |
* | --- |
* | "{rate} per 1,000 audio minutes" |
*
* @param {Seo_Rate_Audio_MinutesInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_rate_audio_minutes = /** @type {((inputs: Seo_Rate_Audio_MinutesInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Rate_Audio_MinutesInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_rate_audio_minutes(inputs)
	if (locale === "pt-BR") return pt_br2_seo_rate_audio_minutes(inputs)
	if (locale === "es") return es_seo_rate_audio_minutes(inputs)
	if (locale === "fr") return fr_seo_rate_audio_minutes(inputs)
	if (locale === "de") return de_seo_rate_audio_minutes(inputs)
	if (locale === "ru") return ru_seo_rate_audio_minutes(inputs)
	if (locale === "it") return it_seo_rate_audio_minutes(inputs)
	return en_seo_rate_audio_minutes(inputs)
});